import { Button } from "north.js";
import React from "react";
import styled from "styled-components";

import { Header, PageWrapper } from "src/shared/components";
import { deviceBreakpoints } from "src/theme/deviceBreakpoints";
import {
  ProfileDisplayDetails,
  ProfileDisplayIdentity,
  ProfileDisplayLayout,
} from "src/views/hacker-directory/shared/ProfileDisplay";
import { DiscoveryProfile } from "src/views/hacker-directory/shared/types";

import DraftProfileBanner from "../DraftProfileBanner";

const STACKED_LAYOUT_BREAKPOINT = 1168;
const COMPACT_DETAILS_BREAKPOINT = 700;

const Profile: React.FC<{
  profile: DiscoveryProfile;
  isPublished: boolean;
  onEdit: () => void;
}> = ({ profile, isPublished, onEdit }) => (
  <>
    <Header
      title="My Profile"
      subtitle="Edit your directory card details, update your project goals, and manage your team status."
    />
    <ProfilePageWrapper stretchHeight={false}>
      <ProfileDisplayLayout
        breakpoints={{
          details: {
            stackedLayout: STACKED_LAYOUT_BREAKPOINT,
            compactDetails: COMPACT_DETAILS_BREAKPOINT,
          },
          identity: {
            sideBySide: [
              {
                minWidth: 540,
                maxWidth: deviceBreakpoints.tablet + 1,
              },
              {
                minWidth: 968,
                maxWidth: STACKED_LAYOUT_BREAKPOINT,
              },
            ],
          },
        }}
      >
        <ProfileDisplayDetails profile={profile} isOwnProfile>
          {!isPublished && <DraftProfileBanner />}
        </ProfileDisplayDetails>
        <MobileAction>
          <MobileEditButton color="secondary" size="lg" onClick={onEdit}>
            Edit Profile
          </MobileEditButton>
        </MobileAction>
        <ProfileDisplayIdentity profile={profile} linkSlackAccount />
      </ProfileDisplayLayout>
      <EditButtonRow $stackedLayoutBreakpoint={STACKED_LAYOUT_BREAKPOINT}>
        <EditButton color="secondary" size="lg" onClick={onEdit}>
          Edit Profile
        </EditButton>
      </EditButtonRow>
    </ProfilePageWrapper>
  </>
);

const ProfilePageWrapper = styled(PageWrapper)`
  padding-bottom: 64px;
`;

const EditButtonRow = styled.div<{ $stackedLayoutBreakpoint: number }>`
  display: flex;
  justify-content: flex-start;
  margin-top: 40px;

  @media (max-width: ${({ $stackedLayoutBreakpoint }) =>
      $stackedLayoutBreakpoint}px) {
    display: none;
  }
`;

const EditButton = styled(Button)`
  border-radius: 4px;
  color: ${({ theme }) => theme.globalConstants.color.textBody};
  font-family: ${({ theme }) => theme.globalConstants.fontFamily.body};
  font-size: 16px;
  font-weight: 700;
  line-height: normal;
`;

const MobileAction = styled.div`
  display: none;

  @media (max-width: ${STACKED_LAYOUT_BREAKPOINT}px) {
    display: block;
    width: 100%;
  }
`;

const MobileEditButton = styled(EditButton)`
  width: 100% !important;
`;

export default Profile;
